/* IMPORT */
import cleanup from './cleanup.js';
import { readable } from '../objects/callable.js';
import Observable from '../objects/observable.js';
/* MAIN */
const disposed = (stack) => {
    const observable = new Observable(false);
    const toggle = () => observable.set(true);
    // Register the cleanup in the current context
    // This ensures that when the context is disposed/re-run, the observable is updated
    cleanup(toggle);
    return readable(observable);
};
/* EXPORT */
export default disposed;
